import {useEffect} from 'react';

import {Cache} from '@aws-amplify/cache';

import {Navigate} from 'react-router-dom';

import {AuthorizingIndicator} from '../components/AuthorizingIndicator';
import {useAccounts} from '../../accounts/hooks/useAccounts';
import {useAuthEventListener} from '../hooks/useAuthEventListener';
import {useAuthTimeout} from '../hooks/useAuthTimeout';

export const IndexPage = () => {
    const {handleClearSelection} = useAccounts();

    useEffect(() => {
        handleClearSelection();
    }, []);

    const authorizing = Cache.getItem('pac-authorizing');
    const isAuthorizing = authorizing === 'yes';

    const authCompletedRef = useAuthEventListener(isAuthorizing);
    useAuthTimeout(isAuthorizing, authCompletedRef);

    if (isAuthorizing) {
        return <AuthorizingIndicator/>;
    }

    return <Navigate to="/accounts"/>;
};
